(function () {
  if (window.moreePanelStacksInitialized) return;
  window.moreePanelStacksInitialized = true;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root) {
    root.querySelectorAll('[data-panel-stack]').forEach(function (section) {
      if (section.dataset.stackInitialized) return;
      section.dataset.stackInitialized = 'true';
      var panels = Array.from(section.querySelectorAll('.layout-panel'));
      var headers = Array.from(section.querySelectorAll('.sticky-stacked__header'));
      if (!panels.length) return;
      var frame = 0;
      var headerFrame = 0;
      var siteHeader = document.querySelector('.section-header');
      function updateVisibleHeader() {
        if (section.dataset.stackMode !== 'headers') return;
        var bounds = siteHeader && siteHeader.getBoundingClientRect();
        var visibleBottom = bounds && bounds.top < window.innerHeight ? Math.max(0, Math.min(window.innerHeight, bounds.bottom)) : 0;
        section.style.setProperty('--stack-header-top', visibleBottom + 'px');
      }
      function trackHeader() {
        headerFrame = 0;
        updateVisibleHeader();
        if (section.dataset.stackMode === 'headers' && siteHeader && siteHeader.getAnimations().some(function (animation) { return animation.playState === 'running'; })) {
          headerFrame = requestAnimationFrame(trackHeader);
        }
      }
      function scheduleHeader() { if (!headerFrame) headerFrame = requestAnimationFrame(trackHeader); }
      function measure() {
        frame = 0;
        section.dataset.stackReady = 'false';
        section.dataset.stackMode = 'static';
        section.style.removeProperty('--stack-step');
        var step = Math.ceil(Math.max.apply(null, headers.map(function (el) { return el.offsetHeight; })));
        var header = document.querySelector('.section-header');
        var inset = parseFloat(getComputedStyle(section).getPropertyValue('--layout-4')) || 16;
        var top = (header ? header.offsetHeight : 0) + inset;
        section.style.setProperty('--stack-step', step + 'px');
        section.style.setProperty('--stack-top', top + 'px');
        var fits = panels.every(function (panel, index) { return panel.offsetHeight + top + index * step + inset <= window.innerHeight; });
        var enabled = section.dataset.stackEnabled !== 'false' && !motion.matches;
        var headerFits = top + step + inset * 4 <= window.innerHeight;
        var mode = enabled && fits ? 'panels' : enabled && headerFits ? 'headers' : 'static';
        section.dataset.stackMode = mode;
        section.dataset.stackReady = String(mode === 'panels');
        updateVisibleHeader();
      }
      function schedule() { if (!frame) frame = requestAnimationFrame(measure); }
      var observer = new ResizeObserver(schedule);
      panels.forEach(function (panel) { observer.observe(panel); });
      var header = document.querySelector('.section-header');
      if (header) observer.observe(header);
      var headerObserver = new MutationObserver(scheduleHeader);
      if (siteHeader) {
        headerObserver.observe(siteHeader, { attributes: true, attributeFilter: ['class', 'style'] });
        siteHeader.addEventListener('transitionrun', scheduleHeader);
        siteHeader.addEventListener('transitionend', scheduleHeader);
      }
      window.addEventListener('resize', schedule, { passive: true });
      window.addEventListener('scroll', scheduleHeader, { passive: true });
      motion.addEventListener('change', schedule);
      if (document.fonts) document.fonts.ready.then(schedule);
      section.addEventListener('focusin', function (event) {
        var mode = section.dataset.stackMode;
        if (mode === 'static' || !event.target.matches(':focus-visible')) return;
        var active = event.target.closest('.layout-panel');
        var index = panels.indexOf(active);
        if (index < 0) return;
        var style = getComputedStyle(section);
        if (mode === 'headers') {
          var inset = parseFloat(style.getPropertyValue('--layout-4')) || 16;
          updateVisibleHeader();
          var clearance = parseFloat(style.getPropertyValue('--stack-header-top')) + parseFloat(style.getPropertyValue('--stack-step')) + inset;
          var bounds = event.target.getBoundingClientRect();
          if (bounds.top < clearance || bounds.bottom > window.innerHeight - inset) {
            window.scrollBy({ top: bounds.top - clearance, behavior: 'instant' });
          }
          return;
        }
        var list = section.querySelector('.sticky-stacked__list');
        var position = list.getBoundingClientRect().top + window.scrollY;
        for (var i = 0; i < index; i++) position += panels[i].offsetHeight + parseFloat(getComputedStyle(panels[i]).marginBottom);
        window.scrollTo({ top: position - parseFloat(style.getPropertyValue('--stack-top')) - index * parseFloat(style.getPropertyValue('--stack-step')), behavior: 'instant' });
      });
      function unload(event) {
        if (!event.target.contains(section)) return;
        observer.disconnect(); headerObserver.disconnect(); cancelAnimationFrame(frame); cancelAnimationFrame(headerFrame);
        window.removeEventListener('resize', schedule);
        window.removeEventListener('scroll', scheduleHeader);
        if (siteHeader) {
          siteHeader.removeEventListener('transitionrun', scheduleHeader);
          siteHeader.removeEventListener('transitionend', scheduleHeader);
        }
        motion.removeEventListener('change', schedule);
        document.removeEventListener('shopify:section:unload', unload);
      }
      document.addEventListener('shopify:section:unload', unload);
      schedule();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
